export default {
  vgn: {
    name: 'Veganistisch',
    emoji: '🌱',
  },
  vgt: {
    name: 'Vegetarisch',
    emoji: '🥬',
  },
  gf: {
    name: 'Glutenvrij',
  },
  df: {
    name: 'Zuivelvrij',
  },
  hal: {
    name: 'Halal',
  },
  'h&s': {
    name: 'Pittig',
    emoji: '🌶',
  },
};
